import { Typography } from "../../atoms/typography";
import { cn } from "../../lib";
import { Box } from "../../primitives";
import { useListItemContext } from "./list-item-context";
import type {
  ListItemContentProps,
  ListItemContentSupportingTextProps,
  ListItemContentTitleProps,
} from "./types";

export const ListItemContent = ({ className, children }: ListItemContentProps) => (
  <Box className={cn("gap-spacing-xs flex flex-1 flex-col justify-center", className)}>
    {children}
  </Box>
);

ListItemContent.displayName = "ListItem.Content";

// The style comes from `variant`: as a class, Typography's default body-md kept
// its desktop size and native face beside it
export const ListItemContentTitle = ({ className, children }: ListItemContentTitleProps) => {
  const { tone, disabled } = useListItemContext();
  return (
    <Typography
      variant="label-sm"
      color={
        disabled
          ? "neutral-foreground-attenuated"
          : tone === "destructive"
            ? "button-destructive-default"
            : "neutral-foreground-default"
      }
      className={className}
    >
      {children}
    </Typography>
  );
};

ListItemContentTitle.displayName = "ListItem.ContentTitle";

export const ListItemContentSupportingText = ({
  className,
  children,
}: ListItemContentSupportingTextProps) => {
  const { disabled } = useListItemContext();
  return (
    <Typography
      variant="body-sm"
      color={disabled ? "neutral-foreground-attenuated" : "neutral-foreground-intermediate"}
      className={className}
    >
      {children}
    </Typography>
  );
};

ListItemContentSupportingText.displayName = "ListItem.ContentSupportingText";
